import { Component, Fragment, h, Prop } from '@stencil/core';
import { TIcon } from '../../../../components';
import { isBreakpointEqualOrLarger } from '../../../../utils/functions';

@Component({
  tag: 'dc-ui-header-nav-breadcrumb-item',
  styleUrl: 'dc-ui-header-nav-breadcrumb-item.scss',
  shadow: true,
})
export class DcUiHeaderNavBreadcrumbItem {
  @Prop() label: string;
  @Prop() isCurrent: boolean;
  @Prop() isRoot: boolean;
  @Prop() level?: number;

  private getIconName(): TIcon {
    return isBreakpointEqualOrLarger('xl') ? 'dc_forward_right' : 'dc_backward_left';
  }

  getItemClasses() {
    return {
      'dc-ui-header-nav-breadcrumb-item': true,
      'dc-ui-header-nav-breadcrumb-item--current': this.isCurrent,
      'dc-ui-header-nav-breadcrumb-item--root': this.isRoot,
    };
  }

  render() {
    return this.isCurrent ? (
      <span
        data-level={this.level}
        class={this.getItemClasses()}
        aria-current="page">
        {this.label}
      </span>
    ) : (
      <Fragment>
        <button
          data-level={this.level}
          type="button"
          class={this.getItemClasses()}>
          {this.label}
        </button>
        <dc-ui-icon
          name={this.getIconName()}
          size="tiny"
          class="separator"
          color="darkBlue02"
        />
      </Fragment>
    );
  }
}
